import { render, staticRenderFns } from "./Roster.vue?vue&type=template&id=9e565960&scoped=true&"
import script from "@/components/roster/Roster.ts?vue&type=script&lang=ts&"
export * from "@/components/roster/Roster.ts?vue&type=script&lang=ts&"
import style0 from "@/components/roster/roster.scss?vue&type=style&index=0&id=9e565960&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e565960",
  null
  
)

export default component.exports